import { useSelector } from "react-redux";

const CanIsee = ({ UserPermissions, children }) => {
  const { permissions } = useSelector((state) => state.profile.user.info);
  return permissions.includes(UserPermissions) ? children : null;
};

export default CanIsee;
